import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import s from './CollapsibleBlock.scss';
var CollapsibleBlock = /** @class */ (function (_super) {
    __extends(CollapsibleBlock, _super);
    function CollapsibleBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showToggleButton: true,
            collapsed: true,
        };
        _this.toggleButtonClick = function (e) {
            var newCollapsedState = !_this.state.collapsed;
            _this.setState({ collapsed: newCollapsedState });
            if (newCollapsedState) {
                _this.props.onCollapsed && _this.props.onCollapsed();
            }
            else {
                _this.props.onExpanded && _this.props.onExpanded();
            }
        };
        return _this;
    }
    CollapsibleBlock.prototype.getElementHeight = function () {
        return this.contentBlock.clientHeight;
    };
    CollapsibleBlock.prototype.componentDidMount = function () {
        this.contentBlockHeight = this.getElementHeight();
        this.setToggleButtonVisibility();
    };
    CollapsibleBlock.prototype.componentDidUpdate = function () {
        this.contentBlockHeight = this.getElementHeight();
        this.setToggleButtonVisibility();
    };
    CollapsibleBlock.prototype.render = function () {
        var _this = this;
        var _a = this.state, collapsed = _a.collapsed, showToggleButton = _a.showToggleButton;
        var _b = this.props, maxHeight = _b.maxHeight, className = _b.className, shutterBlockClassName = _b.shutterBlockClassName, buttonClassName = _b.buttonClassName, buttonTextCollapsed = _b.buttonTextCollapsed, buttonTextExpanded = _b.buttonTextExpanded, children = _b.children, showFade = _b.showFade, fadeClassName = _b.fadeClassName;
        var shutterBlockHeight = collapsed ? maxHeight : this.contentBlockHeight;
        return (React.createElement("div", { className: classnames(s['collapsible-block-component'], className) },
            React.createElement("div", { className: s['fade-container'] },
                React.createElement("div", { className: classnames(s['shutter-block'], shutterBlockClassName, collapsed && s['collapsed']), style: {
                        maxHeight: shutterBlockHeight,
                    } },
                    React.createElement("div", { className: s['content-block'], ref: function (element) { return (_this.contentBlock = element); } }, children)),
                collapsed && showToggleButton && showFade && (React.createElement("div", { className: classnames(s['fade'], fadeClassName) }))),
            showToggleButton && (React.createElement("button", { type: "button", className: classnames(buttonClassName, s['collapse-toggle-button']), onClick: this.toggleButtonClick }, collapsed ? buttonTextCollapsed : buttonTextExpanded))));
    };
    CollapsibleBlock.prototype.setToggleButtonVisibility = function () {
        if (!this.contentBlock) {
            return;
        }
        var hasContentOverflow = this.contentBlockHeight > this.props.maxHeight;
        var shouldShowToggleButton = hasContentOverflow;
        if (this.state.showToggleButton !== shouldShowToggleButton) {
            this.setState({
                showToggleButton: shouldShowToggleButton,
                collapsed: hasContentOverflow && this.state.collapsed,
            });
        }
    };
    return CollapsibleBlock;
}(React.Component));
export default CollapsibleBlock;
//# sourceMappingURL=CollapsibleBlock.js.map